module.exports = "<app-header></app-header>\n<ngx-loading [show]=\"loading\"></ngx-loading>\n<app-home></app-home>\n<app-intro-with-banner></app-intro-with-banner>\n<app-login-signup></app-login-signup>\n<!-- <app-copy-right></app-copy-right> -->\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/landing-page/landing-page.component.html
// module id = ../../../../../src/app/components/landing-page/landing-page.component.html
// module chunks = main